/**
 * Markdown, or HTML that came from outside, made safe to show — the one place
 * it is done (`frontend.md` rule 10); `<Rich>` renders the result.
 */
import DOMPurify from "dompurify";
import { marked } from "marked";

// A link opens in a new tab, away from the app's session.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("href")) {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitise(source: string, kind: "markdown" | "html"): string {
  const html =
    kind === "markdown" ? (marked.parse(source, { async: false, gfm: true }) as string) : source;
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
